import { Select } from '../../../../components/selects/Select';
import { useTranslation } from '../../../../providers/UIProvider';
import { EditorProps } from '../types/editor-props';

/** Yes/No dropdown that commits a real `boolean` (or `null` for empty). */
export function BooleanEditor({ id, value, onChange, onCommit, onBlur }: EditorProps) {
  const t = useTranslation('components.boolean');
  const options = [
    { value: 'true', label: t('TRUE') },
    { value: 'false', label: t('FALSE') }
  ];

  const current = value === true ? 'true' : value === false ? 'false' : '';

  return (
    <Select
      id={id}
      defaultOpen
      autoFocus
      options={options}
      value={current}
      onChange={next => {
        const picked = Array.isArray(next) ? next[0] : next;
        const bool = picked === 'true' ? true : picked === 'false' ? false : null;
        if (onCommit) {
          void onCommit(bool).catch(() => {});
        } else {
          onChange(bool);
        }
      }}
      onBlur={onBlur}
    />
  );
}
